module.exports = __webpack_public_path__ + "img/logo.0977a743.png";